import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Outlet } from "react-router-dom";

export { default as Main } from "./Main";
export { default as CreateEvent } from "./CreateEvent";
export { default as ViewSession } from "./SessionsViewer";
export { default as Answers } from "./AnswersTable";

const EventsMainPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/app/events") navigate("/app/events/all");
  }, [location]);

  return <Outlet />;
};

export default EventsMainPage;
